import { Chip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';


function TechnologyChip() {

    const { t } = useTranslation();

    return (
        <Chip
            icon={<PersonOutlineOutlinedIcon />}
            label={t('chip.technology')}
            variant="filled"
            color="warning"
            size="medium"
            sx={{ width: '100%' }}
        />
    );
};

export default TechnologyChip;